export const directoryUsers = (directory) => {
  return directory
    ? directory.project_contributors.flatMap((pc) => {
        return pc.users.map((user) => user);
      })
    : [];
};
